import React, { Component } from 'react';
import { CloseOutlined, CloudUploadOutlined, DeleteOutlined, FileFilled, RedoOutlined } from '@ant-design/icons';
import { Upload, Modal, Tooltip, Button, Spin, Divider, Checkbox } from 'antd';
import moment from 'moment';
// import Uploadlayer from '../../../components/FormComponent/Input/upload';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import Storage from './../../../services/local-store';
import formDataPostService from '../../../services/httpformData';
import userTrackService from './../../../services/usertrack-service';

const $ = require('jquery');
var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]

class PatientCheckIn extends Component {

    constructor(props) {
        super(props);
        this.state = {

        //   tableData:[],
        //   selectedCheckboxes: [],
        //   modal1Visible:false,
        //   showValidationMessage: false, // Initially hide the validation message,
        //   savebuttonVisible:false
        tableData: [], // Your table data
        selectedCheckboxes: [], // Selected checkboxes
        modal1Visible:false,
        savebuttonVisible: false, // Save button visibility
        isSelectAllChecked: false, // Select All checkbox state
        checkboxesDisabled: false,
        };
      }

      renderTableRows() {
        let { id, slug } = this.props.match.params;
        let { counselling_view, checkboxesDisabled } = this.state;
        let { counselling_details, basic_info } = this.props;
        const params = new URLSearchParams(this.props.location.search);
        const rid = params.get('rid');
      
        if (rid !== '' && rid !== undefined && rid !== null && !isNaN(rid) && slug === 'finanical-counselling') {
          slug = 'recounselling';
        }
        console.log('TEstSlug', slug);
      
        if (slug === 'finanical-counselling') {
          const renderRows = () => {
            return this.state.tableData.map((item, index) => (
              <tr key={index}>
                <td className="text-capitalize align-middle text-center">
                  <input
                    type="checkbox"
                    checked={this.state.selectedCheckboxes.includes(index)}
                    onChange={() => this.handleCheckboxChange(index)}
                    disabled={checkboxesDisabled}
                  />
                </td>
                <td>{item.text}</td>
              </tr>
            ));
          };
      
          return (
            <>
              <tr>
                <td className="text-capitalize align-middle text-center">
                  <input
                    type="checkbox"
                    checked={this.state.isSelectAllChecked}
                    onChange={this.handleSelectAllChange}
                    disabled={checkboxesDisabled}
                  />
                </td>
                <td>Select All</td>
              </tr>
              {renderRows()}
            </>
          );
      
        } else if (slug === 'recounselling') {
          if (counselling_view && counselling_view[0].payment_type === basic_info['payment_name']) {
            return this.state.tableData.map((item, index) => (
              <tr key={index}>
                <td className="text-capitalize align-middle text-center">
                  <input
                    type="checkbox"
                    checked={counselling_view[0].fc_checklist_verified || this.state.selectedCheckboxes.includes(index)}
                    onChange={() => this.handleCheckboxChange(index)}
                    disabled={counselling_view[0].fc_checklist_verified}
                  />
                </td>
                <td>{item.text}</td>
              </tr>
            ));
          } else {
            const renderRows = () => {
              return this.state.tableData.map((item, index) => (
                <tr key={index}>
                  <td className="text-capitalize align-middle text-center">
                    <input
                      type="checkbox"
                      checked={this.state.selectedCheckboxes.includes(index)}
                      onChange={() => this.handleCheckboxChange(index)}
                      disabled={checkboxesDisabled}
                    />
                  </td>
                  <td>{item.text}</td>
                </tr>
              ));
            };
      
            return (
              <>
                <tr>
                  <td className="text-capitalize align-middle text-center">
                    <input
                      type="checkbox"
                      checked={this.state.isSelectAllChecked}
                      onChange={this.handleSelectAllChange}
                      disabled={checkboxesDisabled}
                    />
                  </td>
                  <td>Select All</td>
                </tr>
                {renderRows()}
              </>
            );
          }
        } else {
        //   return this.state.tableData.map((item, index) => (
        //     <tr key={index}>
        //       <td className="text-capitalize align-middle text-center">
        //         <input
        //           type="checkbox"
        //           checked={counselling_view[0].fc_checklist_verified || this.state.selectedCheckboxes.includes(index)}
        //           onChange={() => this.handleCheckboxChange(index)}
        //           disabled={counselling_view[0].fc_checklist_verified}
        //         />
        //       </td>
        //       <td>{item.text}</td>
        //     </tr>
        //   ));
            if(counselling_view){
                return this.state.tableData.map((item, index) => (
                    <tr key={index}>
                    <td className="text-capitalize align-middle text-center">
                        <input
                        type="checkbox"
                        checked={counselling_view[0].fc_checklist_verified || this.state.selectedCheckboxes.includes(index)}
                        onChange={() => this.handleCheckboxChange(index)}
                        disabled={counselling_view[0].fc_checklist_verified}
                        />
                    </td>
                    <td>{item.text}</td>
                    </tr>
                ));
            } else {
                return this.state.tableData.map((item, index) => (
                    <tr key={index}>
                    <td className="text-capitalize align-middle text-center">
                        <input
                        type="checkbox"
                        //   checked={counselling_view[0].fc_checklist_verified || this.state.selectedCheckboxes.includes(index)}
                        onChange={() => this.handleCheckboxChange(index)}
                        disabled={true}
                        />
                    </td>
                    <td>{item.text}</td>
                    </tr>
                ));
            }
        }
      }
      
    handleCheckboxChange = (index) => {
        const { tableData } = this.state;
        const desiredLength = tableData.length;
        this.setState((prevState) => {
          const selectedCheckboxes = [...prevState.selectedCheckboxes];
          if (selectedCheckboxes.includes(index)) {
            // Checkbox was previously selected, remove it
            const checkboxIndex = selectedCheckboxes.indexOf(index);
            selectedCheckboxes.splice(checkboxIndex, 1);
          } else {
            // Checkbox was not selected, add it
            selectedCheckboxes.push(index);
          }
      
          const allSelected = selectedCheckboxes.length === desiredLength;
        //   let fc_checklist_verified = allSelected ? "yes" : "no";
        //   Storage.store('fc_checklist_verified', fc_checklist_verified);
      
          return {
            selectedCheckboxes,
            savebuttonVisible: allSelected,
            isSelectAllChecked: allSelected
          };
        });
      };

      handleSelectAllChange = () => {
        this.setState((prevState) => {
          const allSelected = !prevState.isSelectAllChecked;
          const selectedCheckboxes = allSelected ? this.state.tableData.map((_, index) => index) : [];
      
        //   let fc_checklist_verified = allSelected ? "yes" : "no";
        //   Storage.store('fc_checklist_verified', fc_checklist_verified);
      
          return {
            selectedCheckboxes,
            savebuttonVisible: allSelected,
            isSelectAllChecked: allSelected
          };
        });
      };
      
      
      
      validateCheckboxes = () => {
        const { tableData, selectedCheckboxes } = this.state;
        const desiredLength = tableData.length;
        let fc_checklist_verified = '';
        if (selectedCheckboxes.length === desiredLength) {
            this.setModal1Visible(false);
            fc_checklist_verified = "yes";
            Storage.store('fc_checklist_verified', fc_checklist_verified);
            this.setState({ checkboxesDisabled: true });
            Modal.success({
                title: 'Success',
                content: 'Successfully All checkboxes selected',
              });
        } else {
            this.setModal1Visible(false);
            fc_checklist_verified = "no";
            Storage.store('fc_checklist_verified', fc_checklist_verified);
            Modal.warning({
                title: 'Warning',
                content: 'please select all check boxes',
              });
        }
      }

      
    componentDidMount() {
        let counselling_view = JSON.parse(localStorage.getItem('counselling_view'));
        const fc_checklist_verified = counselling_view && counselling_view.length > 0
        ? counselling_view[0].fc_checklist_verified 
        : false;
        this.setState({counselling_view: counselling_view,savebuttonVisible:false});
        if(counselling_view && counselling_view.length && counselling_view[0].fc_checklist_verified){
            Storage.store('fc_checklist_verified', fc_checklist_verified);
        }
        this.getCheckList(); 
    }


    getCheckList () {
        console.log("here");
        try {
          let user_data;
          if (
            localStorage.getItem('user_data') !== null &&
            localStorage.getItem('user_data') !== undefined &&
            localStorage.getItem('user_data') !== ''
          ) {
            user_data = JSON.parse(localStorage.getItem('user_data'));
          }
          postService('getFCChecklist', 'POST', {
            data: { unit_id: user_data['unitid'] ? user_data['unitid'] : '' }
          })
            .then(res => {
              if (res.status) {
                this.setState({ tableData: res.data[0].data });
              } else {
                this.setState({ tableData: [], fetching: false });
              }
            })
            .catch(error => {
              console.log(error);
              this.setState({ fetching: false });
            });
        } catch (error) {
          console.log(error);
          this.setState({ fetching: false });
        }
      };

    componentWillUnmount() {
        this.setState({
            visible: false,

        });
    }

    initial() {
        this.getMasterDocumentTypes();
        const { id, slug } = this.props.match.params
        if (slug === 'patients-history-details') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        } if (slug === 'pending-docs') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        }
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            let tokenData = JSON.parse(Storage.get('current_token'));
            if (tokenData && tokenData['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'add' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'add' })
            }
        }
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            let view = JSON.parse(Storage.get('counselling_view'));
            if (view && view[0]['umr']) {
                this.setState({ showDocument: true, ui_form_type: 'view' });
                this.getPatientDocumentDetails();
            } else {
                this.setState({ showDocument: false, ui_form_type: 'view' })
            }
        }
        if (slug === 'pre-auth-worklist') {
            let yes = this.props.mydata
            if (yes) {
                let { unit_id, umr_no, ip_no } = this.props.mydata
                if (umr_no) {
                    this.setState({ showDocument: true, hideonHistory: true, ui_form_type: 'view' });
                    this.getPatientDocumentDetails();
                } else {
                    this.setState({ showDocument: false, hideonHistory: true, ui_form_type: 'view' })
                }
            }
        }
    }

    getMasterDocumentTypes() {
        this.setState({ loadding: true })
        let { getMasterDocumentTypes } = networkList;
        try {
            postService(getMasterDocumentTypes, 'GET', {}).then(res => {
                if (res['status']) {
                    this.setState((state) => ({ 'tbody': res['data'] }));
                    this.setState({ loadding: false })
                    Storage.store('getMasterDocumentTypes', res['data'])
                } else {
                    this.setState((state) => ({ 'docTypes': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }

    getPatientDocumentDetails() {
        this.setState({ loadding: true })
        let { getPatientDocumentDetails } = networkList;
        const { id, slug } = this.props.match.params
        let tokenData = JSON.parse(Storage.get('current_token'));
        let user_data = JSON.parse(Storage.get('user_data'));
        let view = JSON.parse(Storage.get('counselling_view'));
        let payload = {}

        if (slug === 'patients-history-details') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('13:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                        console.log('disable_15days', disable_15days, days)
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pending-docs') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('pending-docs:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                        console.log('disable_15days', disable_15days, days)
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': parseInt(counselling_id) })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        if (slug === 'pre-auth-worklist') {
            let yes = this.props.mydata ? this.props.mydata : false
            console.log('13:', this.props.mydata)
            if (yes) {
                let { unit_id, umr_no, ip_no, patient_name, counselling_id, date_of_counselling } = this.props.mydata
                let disable_15days = null
                if (umr_no) {
                    payload = { "umr_no": umr_no, "ip_no": ip_no, "unit_id": unit_id, "form_type": "view", "counselling_id": counselling_id }
                    if (date_of_counselling) {
                        var days = Math.abs((moment(date_of_counselling).diff(moment(new Date()), 'day')));
                        disable_15days = days > 15 ? true : false
                        console.log('disable_15days', disable_15days, days)
                    } else {
                        disable_15days = false
                    }
                    this.setState({ "umr_no": umr_no, "ip_no": ip_no, "patient_name": patient_name, 'disable_15days': disable_15days, hideonHistory: true, ui_form_type: 'view', 'current_counselling_id': counselling_id })
                }
            } else {
                this.setState({ hideonHistory: true, ui_form_type: 'view' })
            }
        }
        // add counselling
        if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
            payload = { "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "unit_id": user_data['unitid'], "form_type": "add", "counselling_id": '' }
            this.setState({ "umr_no": tokenData['umr'], "ip_no": tokenData['ip'], "patient_name": tokenData['patient_name'], ui_form_type: 'add' })
        }
        // view counselling
        if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
            const params = new URLSearchParams(this.props.location.search);
            let ui_counselling_id = params.get('cid');
            let current_counselling_id = this.props.print_counselling_id || ui_counselling_id || '';
            let disable_15days = null
            if (view && view[0]['counselling_date']) {
                var days = Math.abs((moment(view[0]['counselling_date']).diff(moment(new Date()), 'day')));
                disable_15days = days > 15 ? true : false
                console.log('disable_15days', disable_15days, days)
            } else {
                disable_15days = false
            }
            payload = { "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "unit_id": user_data['unitid'], "form_type": "view", "counselling_id": current_counselling_id }
            this.setState({ "umr_no": view[0]['umr'], "ip_no": view[0]['ip_no'], "patient_name": view[0]['patient_name'], 'disable_15days': disable_15days, ui_form_type: 'view', 'current_counselling_id': current_counselling_id })
        }
        try {
            const Userlogobj = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get Patient Document Details - Request",
                    "date": new Date(),
                    "meta": payload
                }
            }
            userTrackService(Userlogobj);
            postService(getPatientDocumentDetails, 'POST', { "data": payload }).then(res => {
                const Userlogobjres = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "get Patient Document Details - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res['status']) {
                    let latest_cou_id = res['latest_counselling_id'] ? res['latest_counselling_id'] : null
                    this.setState((state) => ({ 'patientDocument': res['data'], 'latest_counselling_id': latest_cou_id }));
                    this.setState({ loadding: false })
                    Storage.store('getPatientDocumentDetails', res['data'])
                } else {
                    this.setState((state) => ({ 'patientDocument': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }
    }

   
    deleteDocument = (filesArray) => {
        this.setState({ loadding: true })
        let payload = {}
        let { file_uploading_id } = this.state
        console.log('filesArray', filesArray.length, filesArray.length > 1 ? "remove" : "update")
        if (file_uploading_id) {
            payload = { 'file_uploading_id': file_uploading_id.toString(), action_item: filesArray.length > 1 ? "remove" : "update" }
            try {
                postService('removePatientDocument', 'POST', { "data": payload }).then(res => {
                    if (res['status']) {
                        Modal.success({
                            title: `Success`,
                            content: `${res['message']}`,
                            zIndex: '1022'
                        });
                        this.getPatientDocumentDetails()
                        this.setState({ loadding: false })
                    } else {
                        Modal.error({
                            title: `Failure`,
                            content: `${res['message']}`,
                            zIndex: '1022'
                        });
                        this.setState({ loadding: false })
                    }
                });
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Oops, Something is wrong. Please try again.',
                })

            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Oops, Please try again.`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }

    }
    setModal1Visible(modal1Visible) {
        let checkList = localStorage.getItem('fc_checklist_verified');
        if (checkList === '"yes"') {
            checkList = checkList.replace(/"/g, '');
        }
        if(checkList === "yes"){
        this.setState({ modal1Visible, savebuttonVisible: false});
        }
        else{
            this.setState({ modal1Visible})
        }
        this.initial()
    }

    cancelButton = (modal1Visible) => {
        let checkList = localStorage.getItem('fc_checklist_verified');
        if (checkList === '"yes"') {
            checkList = checkList.replace(/"/g, '');
        }
        if(checkList === "yes"){
            this.setState({
                modal1Visible,
                savebuttonVisible: false,
            });
        }
        else{ 
            this.setState({
            modal1Visible,
               selectedCheckboxes: [],
            savebuttonVisible: false,
            isSelectAllChecked: false,
        });
    
        const fc_checklist_verified = "no";
        console.log('fc_checklist_verified::::', fc_checklist_verified);
        Storage.store('fc_checklist_verified', fc_checklist_verified);
    }
    }
    
    handleChange = ({ fileList }) => {
        console.log('filelist', fileList)

        let file = null,
            file_type = null,
            file_name = null,
            file_size = null;
        if (fileList) {
            // fileList.map(async(item, key) =>
            for (let i = 0; i < fileList.length; i++) {
                let item = fileList[i]
                let key = i
                // fileList[key]['status'] = 'done';
                // fileList[key]['base_64'] = await getBase64(file.originFileObj);            
                file = item.originFileObj;
                file_type = item.type;
                file_name = item.name;
                file_size = item.size;
                // check file type
                const isJpgOrPngOrPdf = file_type == 'image/png' || file_type == 'image/jpg' || file_type == 'image/jpeg' || file_type == 'application/pdf';

                const isLt2M = file_size / 1024 / 1024 < 2;
                if (!isJpgOrPngOrPdf) {
                    Modal.error({
                        title: `(${file_name}) is invalid file.`,
                        content: `Please, upload the following extensions files (.png/.jpg/.pdf) smaller than 2MB only.`,
                        zIndex: '1022'
                    });
                }
                // check file size        
                else if (!isLt2M) {
                    Modal.error({
                        title: `(${file_name}) is invalid file.`,
                        content: `Please, upload the file smaller than 2MB only.`,
                        zIndex: '1022'
                    });
                }

                else {
                    // Modal.success({
                    //     title: `success`,
                    //     content: ``,
                    //     zIndex: '1022'
                    // });
                    console.log('check', isJpgOrPngOrPdf, isLt2M)
                    this.submit(file)
                }
            }
        }
    };

    submit = (file) => {
        this.setState({ loadding: true })
        let user_data = null
        const { id, slug } = this.props.match.params;

        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        } else {
            Modal.error({
                title: `Failure`,
                content: `unit in null.`,
                zIndex: '1022'
            });
        }
        let { umr_no, ip_no, body } = this.state

        if (file && umr_no && body && body.id && body.document_short_code && user_data['unitid']) {
            var num = body.id;
            var doc_id = num.toString();
            var form_data = new FormData();
            var current_counselling_id = '';
            form_data.append('upfile', file);
            form_data.append("umr", umr_no);
            if (body['document_type'] === 'KYC') {
                form_data.append("ip", null);
            } else {
                form_data.append("ip", ip_no);
            }
            form_data.append("document_short_code", body.document_short_code);
            form_data.append("document_id", doc_id);
            form_data.append("unit_id", user_data['unitid']);

            if (slug === 'patients-history-details') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }

            if (slug === 'pending-docs') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }
            if (slug === 'pre-auth-worklist') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }

            if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
                form_data.append("form_type", 'add');
                form_data.append("counselling_id", '');
            }
            if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
                current_counselling_id = this.props.print_counselling_id || '';
                form_data.append("form_type", 'view');
                form_data.append("counselling_id", current_counselling_id);
            }
            try {
                formDataPostService('fileUpload', 'POST', form_data).then(res => {
                    console.log('fileupload response:', res);
                    if (res.status) {
                        Modal.success({
                            title: `success`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.getPatientDocumentDetails();
                        this.setState({ loadding: false })
                    } else {
                        Modal.error({
                            title: `Failure`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.setState({ loadding: false })
                    }

                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Oops, Something is wrong. Please try again.',
                })

            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Oops, something went wrong. Please try again.`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }
    }

    handle2Change = ({ fileList }) => {
        let file = null,
            file_type = null,
            file_name = null,
            file_size = null;
        if (fileList) {
            fileList.map(async (item, key) => {
                file = item.originFileObj;
                file_type = item.type;
                file_name = item.name;
                file_size = item.size;
                // check file type
                const isJpgOrPngOrPdf = file_type == 'image/png' || file_type == 'image/jpg' || file_type == 'image/jpeg' || file_type == 'application/pdf';
                if (!isJpgOrPngOrPdf) {
                    Modal.error({
                        title: `(${file_name}) is invalid file.`,
                        content: `Please, upload the following extensions files (.png/.jpg/.pdf) smaller than 2MB only.`,
                        zIndex: '1022'
                    });
                }
                // check file size        
                const isLt2M = file_size / 1024 / 1024 < 2;
                if (!isLt2M) {
                    Modal.error({
                        title: `(${file_name}) is invalid file.`,
                        content: `Please, upload the file smaller than 2MB only.`,
                        zIndex: '1022'
                    });
                }

                if (isJpgOrPngOrPdf && isLt2M) {
                    console.log('check', isJpgOrPngOrPdf, isLt2M)
                    this.resubmit(file)
                }
            });
        }
    };

    resubmit = (file) => {
        this.setState({ loadding: true })
        let user_data = null
        const { id, slug } = this.props.match.params;
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        } else {
            Modal.error({
                title: `Failure`,
                content: `unit in null.`,
                zIndex: '1022'
            });
        }
        let { umr_no, ip_no, body, file_uploading_id } = this.state
        if (file && umr_no && body && body.id && body.document_short_code && user_data['unitid']) {
            var num = body.id;
            var doc_id = num.toString();

            var current_counselling_id = '';
            var form_data = new FormData();
            form_data.append('upfile', file);
            form_data.append("umr", umr_no);
            if (body['document_type'] === 'KYC') {
                form_data.append("ip", null);
            } else {
                form_data.append("ip", ip_no);
            }
            form_data.append("file_uploading_id", file_uploading_id ? file_uploading_id.toString() : null);
            form_data.append("document_short_code", body.document_short_code);
            form_data.append("document_id", doc_id);
            form_data.append("unit_id", user_data['unitid']);

            if (slug === 'patients-history-details') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }

            if (slug === 'pending-docs') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }
            if (slug === 'pre-auth-worklist') {
                form_data.append("form_type", 'view');
                let yes = this.props.mydata ? this.props.mydata : false;
                if (yes) {
                    let { unit_id, umr_no, ip_no, patient_name, counselling_id } = this.props.mydata
                    form_data.append("counselling_id", counselling_id);
                }
            }


            if (slug === 'counsellor-view' || slug === 'finanical-counselling' || slug === 'insurance-counselling') {
                form_data.append("form_type", 'add');
                form_data.append("counselling_id", '');
            }
            if (slug === 'view-finanical-counselling' || slug === 'view-other-counselling') {
                current_counselling_id = this.props.print_counselling_id || '';
                form_data.append("form_type", 'view');
                form_data.append("counselling_id", current_counselling_id);
            }
  
            try {
                formDataPostService('fileUpload', 'POST', form_data).then(res => {
                    console.log('fileupload response:', res);
                    if (res.status) {
                        Modal.success({
                            title: `success`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.getPatientDocumentDetails();
                        this.setState({ loadding: false })
                    } else {
                        Modal.error({
                            title: `Failure`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.setState({ loadding: false })
                    }

                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Oops, Something is wrong. Please try again.',
                    zIndex: '1022'
                })

            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Oops, something went wrong. Please try again.`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }
    }



    onChange = (evt, body, item) => {
        console.log('checkbox', evt.target.checked);
        const { ui_form_type, current_counselling_id, latest_counselling_id } = this.state;

        if (evt.target.checked) {
            this.checked_true(body);
        } else {
            this.checked_false(item);
        }

        // Perform checkbox validation
        if (ui_form_type === 'view' && current_counselling_id === latest_counselling_id) {
            this.setState({ checkboxError: '' });
        } else if (ui_form_type !== 'view' && this.validateCheckboxes()) {
            this.setState({ checkboxError: '' });
        } else {
            this.setState({ checkboxError: 'Please select at least one checkbox' });
        }
    };

    checked_true = (body) => {
        this.setState({ loadding: true })
        let user_data = null
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        } else {
            Modal.error({
                title: `Failure`,
                content: `unit is null.`,
                zIndex: '1022'
            });
        }
        let ip = null
        let { umr_no, ip_no, latest_counselling_id } = this.state
        if (umr_no && body && body.id && user_data['unitid']) {
            var num = body.id;
            var id = num.toString();

            if (body['document_type'] === 'KYC') {
                ip = null;
            } else {
                ip = ip_no;
            }
            let payload = {
                "umr": umr_no,
                "ip": ip,
                "document_id": id,
                "unit_id": user_data['unitid'],
                "counselling_id": latest_counselling_id
            }
            console.log('form_data:', body, payload);
            try {
                postService('enableFileUpload', 'POST', { 'data': payload }).then(res => {
                    console.log('enableFileUpload response:', res);
                    if (res.status) {
                        // Modal.success({
                        //     title: `success`,
                        //     content: `${res.message}`,
                        //     zIndex: '1022'
                        // });
                        this.getPatientDocumentDetails();
                        this.setState({ loadding: false })
                    } else {
                        Modal.error({
                            title: `Failure`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.setState({ loadding: false })
                    }

                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Oops, Something is wrong. Please try again.',
                    zIndex: '1022'
                })

            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Oops, something went wrong. Please try again.`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }
    }
    checked_false = (item) => {
        this.setState({ loadding: true })
        let file_uploading_id = item ? item['file_uploading_id'] : true
        if (file_uploading_id) {
            let payload = {
                "file_uploading_id": item ? item['file_uploading_id'].toString() : null,
            }
            console.log('form_data:', item, payload);
            try {
                postService('disableFileUpload', 'POST', { 'data': payload }).then(res => {
                    console.log('fileupload response:', res);
                    if (res.status) {
                        // Modal.success({
                        //     title: `success`,
                        //     content: `${res.message}`,
                        //     zIndex: '1022'
                        // });
                        this.getPatientDocumentDetails();
                        this.setState({ loadding: false })
                    } else {
                        Modal.error({
                            title: `Failure`,
                            content: `${res.message}`,
                            zIndex: '1022'
                        });
                        this.setState({ loadding: false })
                    }

                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Error Message',
                    content: 'Oops, Something is wrong. Please try again.',
                    zIndex: '1022'
                })

            }
        } else {
            Modal.error({
                title: `Failure`,
                content: `Oops, something went wrong. Please try again.`,
                zIndex: '1022'
            });
            this.setState({ loadding: false })
        }
    }

   

    

    render() {
        console.log("PatientCheckIN");
        let { tbody, showDocument, patientDocument, thead, umr_no, ip_no, patient_name, fileList, loadding, hideonHistory, ui_form_type, disable_15days,
            current_counselling_id, latest_counselling_id,savebuttonVisible,counselling_view,selectedCheckboxes, tableData } = this.state
        let pat_doc_ids = []
        const { id, slug } = this.props.match.params
      
        const desiredLength = tableData.length;
      const allCheckboxesSelected = selectedCheckboxes.length === desiredLength;
        return (<React.Fragment>
            {slug === 'patients-history-details' || slug === 'pending-docs' || slug === 'pre-auth-worklist' ? null : <React.Fragment> {showDocument ?
                <div className={`col-10 mb-2 icon mx-auto p-2 text-center doc-ena`} style={{ backgroundColor: '#666' }} onClick={() => { this.setModal1Visible(true); }}>
                    {/* this.initial() */}
                    <FileFilled style={{ fontSize: 18, color: '#ffff' }} />
                    <p className="mt-2 mb-0">Patient Check</p>
                </div>
                :
                <div className={`col-10 mb-2 icon mx-auto p-2 text-center doc-dis`} style={{ backgroundColor: '#666' }} onClick={() => { this.setModal1Visible(true); }}>
                    <FileFilled style={{ fontSize: 18, color: '#ffff' }} />
                    <p className="mt-2 mb-0">Patient Check</p>
                </div>
            }</React.Fragment>}
            <Modal
                // title="Upload Documents"
                centered
                visible={this.state.modal1Visible}
                width='95%'
                height='95%'
                zIndex={1021}
                footer={null}
            >
                <CloseOutlined type="close" className=" popup-close" onClick={() => this.cancelButton(false)}/>
                {ui_form_type === 'view' && disable_15days == true ?
                    <React.Fragment>
                        <h4 className="text-center" style={{ paddingBottom: '5%' }}>Check List</h4>
                    </React.Fragment>
                    :
                    <React.Fragment>
                        <h4 className="text-center" style={{ paddingBottom: '5%' }}>Check List</h4>
                    </React.Fragment>}
                {(loadding) && <div className="loadding h-100 w-100" style={{ left: 0, zIndex: 9999 }}> <Spin ></Spin></div>}

                <div className="financial-table table-responsive pop-table">

      <table className="table table-hover table-bordered mb-0 bg-white">
        <thead style={{ backgroundColor: '#084b69' }}>
          <tr className="pop-table">
            <th className="text-capitalize align-middle text-center">#</th>
            <th>Key Points</th>
          </tr>
        </thead>
        <tbody>
          {this.renderTableRows()}
        </tbody>
      </table>
      <div className="text-center m-4">
        <button className="btn btn-next px-5 mx-2" onClick={() => this.cancelButton(false)}>Close</button>
        {this.state.savebuttonVisible && (
          <button className="btn btn-success text-capitalize px-5 mx-2" onClick={this.validateCheckboxes}>
            Save
          </button>
        )}
      </div>

                </div>
            </Modal>
        </React.Fragment>)
    }
}
export default PatientCheckIn;